import { api } from "@/lib/api";

const espera = (ms) => new Promise((r) => setTimeout(r, ms));

// Publica el cobro en Transbank C2C y espera el resultado del equipo. base: "/tbk-c2c" o "/public/kiosk/{slug}/c2c"
export async function c2cCobrar({ base = "/tbk-c2c", terminalId, monto, onEstado, cancelRef, client = api }) {
  const { data: p } = await client.post(`${base}/pagos`, { terminal_id: terminalId, amount: Math.round(monto) });
  onEstado?.("Cobro enviado al equipo Transbank. Pasa o acerca la tarjeta…");
  const fin = Date.now() + 5 * 60 * 1000;
  let cancelPedido = false;
  while (Date.now() < fin) {
    await espera(2500);
    if (cancelRef?.current && !cancelPedido) {
      cancelPedido = true;
      onEstado?.("Cancelando el cobro en Transbank…");
      try {
        const { data: c } = await client.post(`${base}/pagos/${p.trace_id}/cancelar`);
        if (c.estado === "CANCELADO") return { aprobado: false, ...c, mensaje: "Cobro cancelado" };
        if (c.estado !== "CREADO" && !c.resultado) onEstado?.("El equipo ya tomó el cobro: termina o anula en el equipo…");
      } catch (e) { /* se reintenta al consultar */ }
    }
    let r;
    try { ({ data: r } = await client.get(`${base}/pagos/${p.trace_id}`)); } catch (e) { continue; }
    if (r.estado === "INFORMADO") onEstado?.("Esperando que el cliente pague en el equipo Transbank…");
    if (r.resultado) {
      return { aprobado: r.resultado === "APROBADO", ...r,
        mensaje: r.resultado === "CANCELADO" ? "Cobro cancelado" : (r.mensaje || (r.resultado === "APROBADO" ? "Aprobado" : "Pago rechazado en el equipo")) };
    }
  }
  return { aprobado: false, trace_id: p.trace_id, mensaje: "Tiempo de espera agotado: revisa el equipo Transbank" };
}
